import { validateInputs } from "shared/utils/Utils";
import style from "./BrandRegistration.module.css";
import { requester } from "App";
import Container from "layouts/container/Container";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import InputText from "components/inputs/signUp/InputText";
import { useRef } from "react";
import { textFormat } from "InitialData/regExp";
import { toast } from "react-toastify";
import CustomButton from "components/buttons/CustomButton";
import InputImage from "components/inputs/image/InputImage";

function BrandRegistration() {
    const inputs = useRef([]);

    const onClick = () => {
        let data = {
            brandName: "",
            contents: "",
            brandImg: "",

        }
        
        validateInputs(inputs.current).then((result) => {

            if (result.isValid) {
                data.brandName = inputs.current[0].getValue();
                data.contents = inputs.current[1].getValue();
                data.brandImg = inputs.current[2].getValue();

                requester.createBrand(data, (result) => {
                    if (result.code === 0) {
                        
                        toast.success(`상품등록이 완료되었습니다`, {
                            autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                        });
                    }
                });

            } else {
                toast.error(`${inputs.current[result.index].getName()} 항목을 확인해주세요`, {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }


        });

    }
    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }
    return (
        <Container>
            <Container maxWidth={1200}>
                <Center width={"100%"} textAlign={"left"}>
                    <P size={40} font={"gmarketSansBold"}>브랜드 등록</P>
                </Center>
                <VerticalFlex flexStart padding={"30px"} gap={20}>

                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>상품명 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputText ref={el => (inputs.current[0] = el)} placeHolder={"브랜드명"} regExp={[textFormat]} />
                            </FlexChild>
                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>설명 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputText ref={el => (inputs.current[1] = el)} placeHolder={"설명"} regExp={[textFormat]} />
                            </FlexChild>
                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>브랜드 이미지 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputImage ref={el => (inputs.current[2] = el)} name={"브랜드 이미지"} path={"brand/"} labelWidth={0} cropWidth={750} cropHeight={370} maxSizeMb={1} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    {/* <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>상품가격 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputText ref={el => (inputs.current[1] = el)} placeHolder={"상품가격"} regExp={[textFormat]} />
                            </FlexChild>

                        </HorizontalFlex>

                    </FlexChild> */}

                    <FlexChild>
                        <CustomButton style={btnStyle} text={"상품 등록"} onClick={onClick} />
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container >
    );
}

export default BrandRegistration;